import { FacebookState } from ".";
import { RootState } from "../types";
import { ActionTree } from "vuex";
import FBService from "../../services/facebook";

export const actions: ActionTree<FacebookState, RootState> = {
  fetchCampaigns({ commit }, { accountId, name }) {
    commit("resetCampaigns");
    return FBService.getCampaigns(accountId, name).then(({ data }) => {
      commit("setCampaigns", data);
    });
  },
  fetchAdvideos({ commit }, { accountId, title }) {
    commit("resetAdvideos");
    return FBService.getAdvideos(accountId, title).then(({ data }) => {
      commit("setAdvideos", data);
      return data;
    });
  },
  fetchImages({ commit }, { accountId, name }) {
    commit("resetImages");
    return FBService.getImages(accountId, name).then(({ data }) => {
      commit("setImages", data);
      return data;
    });
  },
  fetchAudiences({ commit }, { accountId, name }) {
    commit("resetAudiences");
    return FBService.getAudiences(accountId, name).then(({ data }) => {
      commit("setAudiences", data);
      return data;
    });
  },
  fetchRequests({ commit }, { accountId, title }) {
    commit("requests", []);
    return FBService.asyncRequests(accountId, title).then(batches => {
      commit("requests", batches);
    });
  },
  fetchAccounts({ commit }) {
    commit("accounts", []);
    return FBService.accounts().then(({ data }) => {
      commit("accounts", data);
    });
  },
  async checkAdStatuses(
    { commit },
    { accountId, videos }: { accountId: string; videos: any[] }
  ) {
    const isNewAdRequest = FBService.getAds(accountId);
    const removeExt = (s: string) => String(s).split(".")[0];
    const wait = (n: number) => new Promise(res => setTimeout(res, n));

    for (const v of videos) {
      const { data } = await isNewAdRequest(removeExt(v.title));

      commit("setAdStatuses", { adId: v.id, isNew: !data.length });

      await wait(500);
    }
  },

  deleteAdCreative(
    _,
    { accountId, adId }: { accountId: string; adId: string }
  ) {
    return FBService.deleteAd(accountId, adId);
  }
};
